import apiFetch from '../../apiFetch'

export default function (id, token) {
  return apiFetch({endPoint: `Microbiologia/getMicrobiologia?idMicrobiologia=${id}`, method: 'GET', body: null, token: token})
}
